import { FileSpreadsheet, FileText } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const ExportDialog = ({
  open,
  onOpenChange,
  exportDateRange,
  setExportDateRange,
  exportFilter,
  setExportFilter,
  exportFormat,
  setExportFormat,
  activeCount,
  totalCount,
  onExport,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Export Employee List</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          {/* Employee Filter */}
          <div className="space-y-3">
            <Label className="font-medium">Which employees?</Label>
            <RadioGroup value={exportFilter} onValueChange={setExportFilter} className="flex gap-6">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="active" id="filter-active" />
                <Label htmlFor="filter-active" className="font-normal cursor-pointer">Active Only ({activeCount})</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="all" id="filter-all" />
                <Label htmlFor="filter-all" className="font-normal cursor-pointer">All Employees ({totalCount})</Label>
              </div>
            </RadioGroup>
          </div>

          {/* Date Range Filter */}
          <div className="space-y-3">
            <Label className="font-medium">Filter by hire date (optional)</Label>
            <div className="grid grid-cols-2 gap-4">
              <div className="form-group">
                <Label className="text-sm text-muted-foreground">Start Date</Label>
                <Input
                  type="date"
                  value={exportDateRange.start}
                  onChange={(e) => setExportDateRange({ ...exportDateRange, start: e.target.value })}
                  data-testid="export-start-date"
                />
              </div>
              <div className="form-group">
                <Label className="text-sm text-muted-foreground">End Date</Label>
                <Input
                  type="date"
                  value={exportDateRange.end}
                  onChange={(e) => setExportDateRange({ ...exportDateRange, end: e.target.value })}
                  data-testid="export-end-date"
                />
              </div>
            </div>
          </div>

          {/* Export Format - Updated to Excel/PDF */}
          <div className="space-y-3">
            <Label className="font-medium">Choose format</Label>
            <div className="grid grid-cols-2 gap-4">
              <Button
                variant={exportFormat === "excel" ? "default" : "outline"}
                className="h-20 flex-col gap-2"
                onClick={() => setExportFormat("excel")}
                data-testid="format-excel-btn"
              >
                <FileSpreadsheet className={`w-6 h-6 ${exportFormat === "excel" ? "" : "text-green-600"}`} />
                <span>Excel (.xlsx)</span>
              </Button>
              <Button
                variant={exportFormat === "pdf" ? "default" : "outline"}
                className="h-20 flex-col gap-2"
                onClick={() => setExportFormat("pdf")}
                data-testid="format-pdf-btn"
              >
                <FileText className={`w-6 h-6 ${exportFormat === "pdf" ? "" : "text-red-600"}`} />
                <span>PDF</span>
              </Button>
            </div>
          </div>

          {/* Action Button */}
          <Button onClick={onExport} className="w-full" data-testid="confirm-export-btn">
            Export {exportFormat === "excel" ? "Excel" : "PDF"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExportDialog;
